import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PaymentImport } from '../../../dto/payment-import';
import { Payment } from '../../../dto/payment';
import { DateFormats } from '../../../providers/app-date-adapter';
import { PaymentImportService } from '../../services/payment-import.service';
import {MatTableDataSource} from '@angular/material/table';
import {OrderImportError} from '../../../dto/order-import-error';
import {PaymentImportError} from '../../../dto/payment-import-error';

@Component({
  selector: 'app-payment-import-view',
  templateUrl: './payment-import-view.component.html',
  styleUrls: ['./payment-import-view.component.css']
})

export class PaymentImportViewComponent implements OnInit {



  import: PaymentImport;
  importDataDataSource: MatTableDataSource<Payment>;
  importErrorsDataDataSource: MatTableDataSource<PaymentImportError>;

  importCols = [
    { header: 'Id',           cell: (row: PaymentImport) => `${row.id}`},
    { header: 'Date',         cell: (row: PaymentImport) => `${this.datePipe.transform(row.date, DateFormats.DisplayDate)}`},
    { header: 'User',         cell: (row: PaymentImport) => `${row.username}`},
    { header: 'Invalid rows', cell: (row: PaymentImport) => `${row.invalidRowCount}`},
    { header: 'Total rows',   cell: (row: PaymentImport) => `${row.totalRowCount}`},
  ];

  importDataCols = [
    { columnDef: 'date',             header: 'Date',     cell: (row: Payment) => `${this.datePipe.transform(row.date, DateFormats.DisplayDate)}` },
    /*{ columnDef: "orderId",          header: "Order ID", cell: (row: Payment) => `${row.orderId}`},*/
    { columnDef: 'token',            header: 'Token or Code',    cell: (row: Payment) => `${row.token}`},
    { columnDef: 'amount',           header: 'Amount',   cell: (row: Payment) => `${row.amount}`},
    { columnDef: 'importErrorsText', header: 'Errors',   cell: (row: Payment) => `${row.importErrorsText}` },
  ];

  importErrorsCols = [
    { columnDef: 'rowNumber',   header: 'Row number',   cell: (row: PaymentImportError) => `${row.rowNumber}`},
    { columnDef: 'ParsedValue', header: 'Parsed value', cell: (row: PaymentImportError) => `${row.parsedValue}`},
    { columnDef: 'errorText',   header: 'Error Text',   cell: (row: PaymentImportError) => `${row.errorText}`},

  ];
  constructor(
    private paymentImportService: PaymentImportService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    const id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.paymentImportService.get(id).subscribe(result => {
      this.import = result;
      this.importDataDataSource = new MatTableDataSource(result.payments);
      this.importErrorsDataDataSource = new MatTableDataSource(result.importErrors);
    });
  }

  getRowClass = (item: Payment): string => item.importErrorsText ? 'warning-row' : '';

  getRowErrorClass = (item: PaymentImportError): string => item.errorText ? 'warning-row' : '';
}
